import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, Typography, Box, Chip, Grid, TextField, Dialog, DialogTitle, DialogContent, DialogActions, Snackbar, Alert } from "@mui/material";
import SelectPartyPage from "./SelectPartyPage";
import { setAddOrderStoryState } from "store/slice/AppSlice";
import { setSelectedPartyId, setSelectedProductId } from "store/slice/PharmaSlice";
import AddProductPage from "./AddProductPage";
import ProductEditFormImpl from "components/product/ProductEditFormImpl";
import { clearErrMsg } from "store/slice/AppSlice";
import { clearInfoMsg } from "store/slice/AppSlice";
import ProductDashboard from "components/product/ProductDashboard";
import AddOrderProductDashboard from "./AddOrderProductDashboard";
import SubmitOrderConfirmation from "./SubmitOrderConfirmation";


export default function AddOrderStory() {
  const dispatch = useDispatch();
  const { addOrderStory } = useSelector((state) => state.appslice);
  const { partyObj } = useSelector((state) => state.pharmaslice.partyDashboard);
  const { errMsg, infoMsg } = useSelector((state) => state.appslice);
  const [openInfo, setOpenInfo] = useState(false);
  const {pharmaorderObj} = useSelector((state) => state.pharmaslice.pharmaorderDashboard);

  useEffect(() => {
    if (pharmaorderObj && pharmaorderObj.orderstatus !== "DRAFT") {
    dispatch(setAddOrderStoryState({
                    title: "Order # "+pharmaorderObj.id+" Submitted",
                    description: "Add products to the order for the selected party",
                    currentState: "ORDER_SUBMITTED",
                  }));
    }
  },[pharmaorderObj]);
  
  useEffect(() => {
    dispatch(setSelectedProductId(-1)); // Reset selected product ID when the story starts
    dispatch(setSelectedPartyId(-1)); // Reset selected party ID when the story starts
    dispatch(setAddOrderStoryState({ // Initialize the add order story state
      title: "Select A Party",
      description: "Select a party to add an order",
      currentState: "SELECT_PARTY",
    }));
  }, []);
  useEffect(() => {
      if (infoMsg) {
        setOpenInfo(true);
        const timer = setTimeout(() => {
          setOpenInfo(false);
          dispatch(clearInfoMsg()); // Reset infoMsg in store
        }, 5000);
        return () => clearTimeout(timer);
      }
    }, [infoMsg, dispatch]);

  useEffect(() => {

    if (!partyObj) {
      console.log('partyObj is null or undefined');
      dispatch(setSelectedPartyId(-1)); 
    }
  }, [addOrderStory,partyObj]);

  const getComponent = () => {
    if (addOrderStory.currentState === 'SELECT_PARTY') {
      return <SelectPartyPage />;
    } else if (addOrderStory.currentState === 'ADD_PRODUCT_TO_ORDER') {
      return <AddProductPage />;
    } else if (addOrderStory.currentState === 'ENTER_PRODUCT_DETAILS') {
      return <AddOrderProductDashboard />;
    } else if (pharmaorderObj && pharmaorderObj.orderstatus === "MD APPROVAL") {
          return <SubmitOrderConfirmation />;
    }
    else {
      return <Grid >Component not FOUND</Grid>;
    }

  };
  const handleCloseError = () => {
    dispatch(clearErrMsg(""));
  };

  const handleCloseInfo = () => {
    setOpenInfo(false);
    dispatch(clearErrMsg("infoMsg")); // Reset infoMsg in store
  };

  return (
    <>
      <Dialog open={!!errMsg} onClose={handleCloseError} maxWidth="xs" fullWidth>
        <DialogTitle sx={{ bgcolor: 'error.main', color: 'white', display: 'flex', alignItems: 'center' }}>
          Error
        </DialogTitle>
        <DialogContent >
          <Typography variant="h6" sx={{ paddingTop: 2 }}>
            {errMsg}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="error" onClick={handleCloseError}>
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={!!infoMsg && openInfo}
        autoHideDuration={5000}
        onClose={handleCloseInfo}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={handleCloseInfo}
          severity="info"
          sx={{ width: '100%' }}
          variant="filled"
        >
          {infoMsg}
        </Alert>
      </Snackbar>

      <Grid container direction="column" sx={{ width: '100%', backgroundColor: 'secondary.lighter', }}>
        <Grid lg={12} xs={12} item sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2 }}>
          <Typography variant="h4" sx={{ color: 'primary.main', fontWeight: 'bold', borderBottom: '2px solid grey' }}>
            {addOrderStory.title}
          </Typography>
        </Grid>
        {getComponent()}
      </Grid>
    </>

  );
}